import { useTranslation } from 'react-i18next'
import tracking from 'src/tracking'

import { ActionButtonProps } from '../../components/atoms/ActionButton'
import { ActionButtonVariant } from '../../components/atoms/ActionButton/styled'
import { ShareButtonProps } from '../../components/atoms/ShareButton'
import { Icons } from '../../components/atoms/Icon'
import { Network } from '../../components/atoms/ShareButton/styled'

export const usePageActions = ({
  text,
  url,
}: {
  id: string
  text?: string
  url?: string
  brand?: string
}): (ActionButtonProps | ShareButtonProps)[] => {
  const { t } = useTranslation()

  const HandlePrint = () => {
    if (typeof window !== undefined) {
      window.print()
    }
    tracking.print('', text ?? '')
  }

  return [
    {
      label: t('print'),
      iconPosition: 'left',
      iconProps: {
        icon: Icons.print,
      },
      onClick: () => HandlePrint(),
      variant: ActionButtonVariant.secondary,
    },
    {
      label: t('share'),
      iconPosition: 'left',
      iconProps: {
        icon: Icons.share,
      },
      variant: ActionButtonVariant.secondary,
      sharingActions: [
        {
          href: `https://facebook.com/sharer/sharer.php?u=${url}`,
          text: 'Facebook',
          iconPosition: 'left',
          iconProps: {
            icon: Icons.socialFacebook,
          },
          network: Network.facebook,
          onClick: () => tracking.share('', text, Network.facebook),
        },
        {
          href: `https://twitter.com/intent/tweet/?text=${encodeURIComponent(
            `${text} - ${url}`
          )}&amp;url=${url}`,
          text: 'X',
          iconPosition: 'left',
          iconProps: {
            icon: Icons.socialXWhite,
          },
          network: Network.twitter,
          onClick: () => tracking.share('', text, Network.twitter),
        },
      ],
    },
  ]
}
